import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerProfileV2.graphql';
import { Query, QueryinfluencerProfileV2Args } from '../../__generated__/globalTypes';

export const useInfluencerProfileV2Query = (options?: QueryHookOptions<Query, QueryinfluencerProfileV2Args>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerProfileV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerProfileV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerProfileV2Args>
): QueryResult<Query, QueryinfluencerProfileV2Args> & {
  getInfluencerProfileV2: LazyQueryExecFunction<Query, QueryinfluencerProfileV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerProfileV2, result] = useLazyQuery<Query, QueryinfluencerProfileV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerProfileV2, ...result };
};

export const useInfluencerProfileV2PromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerProfileV2 = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerProfileV2Args, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerProfileV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerProfileV2 };
};
// Suspense Query Hooks
export const useInfluencerProfileV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerProfileV2Args>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerProfileV2Args>(QUERY, {
    ...options
  });

  return result;
};
